import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Loader2, ArrowLeft } from "lucide-react";
import { Link } from "@/lib/router-compat";
import ReactMarkdown from "react-markdown";

const PrivacyPolicy = () => {
  const [title, setTitle] = useState("Privacy Policy");
  const [body, setBody] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("site_content")
      .select("*")
      .eq("content_key", "privacy_policy")
      .single()
      .then(({ data }) => {
        if (data) {
          setTitle(data.title);
          setBody(data.body);
        }
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-[100dvh] bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <div className="mb-6">
        <Link
          to="/"
          className="inline-flex min-h-11 items-center gap-2 border border-border px-4 text-sm font-body text-foreground/80 hover:text-gold hover:border-gold transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Wine Trail
        </Link>
      </div>
      <h1 className="font-display text-3xl font-bold text-foreground mb-8">
        {title}
      </h1>
      <div className="prose prose-sm max-w-none">
        <ReactMarkdown
          components={{
            h2: ({ children }) => (
              <h2 className="font-display text-xl font-bold text-foreground mt-8 mb-4">
                {children}
              </h2>
            ),
            h3: ({ children }) => (
              <h3 className="font-display text-lg font-semibold text-foreground mt-6 mb-3">
                {children}
              </h3>
            ),
            p: ({ children }) => (
              <p className="text-muted-foreground font-body leading-relaxed mb-4">
                {children}
              </p>
            ),
            li: ({ children }) => (
              <li className="ml-4 text-muted-foreground font-body leading-relaxed">
                {children}
              </li>
            ),
            ul: ({ children }) => (
              <ul className="list-disc mb-4">{children}</ul>
            ),
            strong: ({ children }) => (
              <strong className="text-foreground">{children}</strong>
            ),
            a: ({ href, children }) => (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:text-primary/80"
              >
                {children}
              </a>
            ),
          }}
        >
          {body}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
